import { Ti18nKeys } from "./i18n";
import { DEFAULT_TIME } from "./input-entries-constants";
import {
  ALL_COUNTRY_PICKER_ENTRIES,
  DEFAULT_ET3_PICKER_SINGLE_VALUE
} from "./picker-entries-constants";
import { TPaidUsersInformation } from "../Types";

export const minAge = 18;
export const maxAge = 77;

export const minHeight = 120;
export const maxHeight = 219;

export const minWeight = 30;
export const maxWeight = 119;

export const MIN_USER_ADVANCED_CRITERIA_SEARCH_NUMBER = 3;

export const COUNTRIES = () => {
  let countries = [DEFAULT_ET3_PICKER_SINGLE_VALUE];
  return countries.concat(ALL_COUNTRY_PICKER_ENTRIES);
};

const numberPicker = ({
  minValue,
  maxValue
}: {
  minValue: number;
  maxValue: number;
}) => {
  const arrayConstructor = Array.from(Array(maxValue + 1).keys());
  const arrayLimits = arrayConstructor.filter((val) => {
    return val >= minValue && val <= maxValue;
  });
  const filledArray = arrayLimits.map((acceptedValue) => {
    return { label: `${acceptedValue}`, value: `${acceptedValue}` };
  });
  return [DEFAULT_ET3_PICKER_SINGLE_VALUE, ...filledArray];
};

export const ALLOWED_AGES = numberPicker({
  minValue: minAge,
  maxValue: maxAge
});

export const ALLOWED_HEIGHTS = numberPicker({
  minValue: minHeight,
  maxValue: maxHeight
});

export const ALLOWED_WEIGHTS = numberPicker({
  minValue: minWeight,
  maxValue: maxWeight
});

export const USER_DEFAULT_DATA = [
  {
    userId: 0,
    userUUID: "",
    username: "",
    statusChangeDate: "",
    gender: "",
    religion: "",
    subreligion: "",
    status: "",
    isSilentBanned: 0,
    silentBannedOn: "",
    emailStatus: "",
    facebookVerify: "",
    smsVerify: "",
    emailVerify: "",
    appleVerify: "",
    emailNotification: "",
    pushNotification: "",
    descriptionID: -1,
    description: "",
    descriptionStatus: "",
    descriptionLanguage: "",
    descriptionIsGeneratedByAi: 0,
    peerDescriptionID: -1,
    peerDescription: "",
    peerDescriptionStatus: "",
    peerDescriptionLanguage: "",
    createdOn: "",
    createdFrom: "",
    originCountry: "",
    residenceCountry: "",
    cityName: "",
    selfieVerificationCompletedOn: "",
    numberOfVerifiedApprovedPictures: 0,
    loginCount: 0,
    state: "",
    ipAddress: "",
    verificationStatus: "",
    verificationCode: "",
    referralCode: "",
    mobileAppPlatform: "",
    mobileAppVersion: "",
    deviceId: "",
    device_token: "",
    isFlagged: 0,
    reportsSent: 0,
    reportsReceived: 0,
    temporaryBannedCount: 0,
    warningCount: 0,
    userUnderCSRInvestigation: false,
    userUnderInvestigationAndReadyToResolve: false,
    userUnderCSRReport: 0,
    wasPaying: false,
    wasStripeUser: false,
    isPaidVIP: false,
    isPaidPlus: false,
    isPaidAlkhattabat: false,
    isPaidBoost: false,
    isPaidRewind: false,
    isPaidSilver: false,
    isPaidGold: false,
    isPaidBlack: false,
    isPaidPlatinum: false,
    isPaidPower: false,
    isSubscribedVIP: false,
    isSubscribedPlus: false,
    isSubscribedAlkhattabat: false,
    isSubscribedBoost: false,
    isSubscribedRewind: false,
    isSubscribedSilver: false,
    isSubscribedGold: false,
    isSubscribedBlack: false,
    isSubscribedPlatinum: false,
    isSubscribedPower: false,
    lastLogin: 0,
    payingKhattabatUntil: DEFAULT_TIME,
    freemiumVIPUntil: DEFAULT_TIME,
    freemiumPLUSUntil: DEFAULT_TIME,
    freemiumSilverUntil: DEFAULT_TIME,
    freemiumGoldUntil: DEFAULT_TIME,
    freemiumBlackUntil: DEFAULT_TIME,
    freemiumPlatinumUntil: DEFAULT_TIME,
    payingVIPUntil: DEFAULT_TIME,
    payingPLUSUntil: DEFAULT_TIME,
    payingBOOSTUntil: DEFAULT_TIME,
    payingREWINDUntil: DEFAULT_TIME,
    payingSilverUntil: DEFAULT_TIME,
    payingGoldUntil: DEFAULT_TIME,
    payingBlackUntil: DEFAULT_TIME,
    payingPlatinumUntil: DEFAULT_TIME,
    payingPowerUntil: DEFAULT_TIME,
    userAppLanguage: "",
    isTester: false,
    deactivatedOn: DEFAULT_TIME,
    deactivationCounter: 0,
    phoneDetails: "",
    profilePublicID: "",
    khattabaAssigned: "",
    hasAccessToBoosts: false,
    hasAccessToRewinds: false,
    hasAccessToReadReceipts: false,
    hasAccessToNewConversationsDaily: false,
    hasAccessToNewConversationsWeekly: false,
    hasAccessToOpenUnlimitedConversations: false,
    hasRemainingBoosts: false,
    hasRemainingRewinds: false,
    hasRemainingReadReceipts: false,
    hasRemainingNewConversationsDaily: false,
    hasRemainingNewConversationsWeekly: false,
    hasAccessToLikes: false,
    hasAccessToLikesDaily: false,
    hasRemainingLikes: false,
    hasRemainingLikesDaily: false,
    emails: [
      {
        userEmail: "",
        verificationPlatform: "",
        verificationActive: 0,
        userActivityEmailsSubscription: 0,
        promotionalEmailsSubscription: 0,
        newMessageEmailsSubscription: 0,
        visitProfileEmailsSubscription: 0,
        likeEmailsSubscriptio: 0,
        userActivityEmailsSettingsOn: 0,
        promotionalEmailsSettingsOn: 0,
        newMessageEmailsSettingsOn: 0,
        visitProfileEmailsSettingsOn: 0,
        likeEmailsSettingsOn: 0
      }
    ]
  }
];

export const USER_ACCOUNT_DELETIO_REASONS_ORDERED: Ti18nKeys[] = [
  "ER3ARRAF_IS_HARD_TO_USE",
  "NOT_ABLE_TO_FIND_PARTNER",
  "FOUND_PARTNER_THROUGH_ET3ARRAF",
  "FOUND_PARTNER_OUTSIDE_ET3ARRAF",
  "NOT_AS_EXPECTED",
  "OTHER_REASONS"
];

export const DELETE_ACCOUNT_HAPPY_REASON = `😁`;

export const DELETE_ACCOUNT_NORMAL_REASON = `😏`;

export const DELETE_ACCOUNT_SAD_REASON = `😔`;

export const PENDING_RECEIPT_TITLES: Ti18nKeys[] = [
  "RECEIPT_HAS_PENDING",
  "RECEIPT_PRODUCT_ID",
  "RECEIPT_EXPIRATION_INTENT",
  "RECEIPT_IS_IN_BILLING_RETRY",
  "RECEIPT_ORIGINAL_TRANSACTION_ID",
  "RECEIPT_AUTO_RENEW_STATUS",
  "RECEIPT_AUTO_RENEW_PRODUCT_ID"
];

export const KHATTABAT_MATCHING_USER_INFORMATION_DEFAULT: TPaidUsersInformation =
  {
    alkhatabaUUID: "",
    userUUID: "",
    userId: -1,
    userName: "",
    gender: "",
    userStatus: "",
    isActivePaidUser: 0,
    totalUnreadMessages: 0
  };

export const ACCOUNT_CREATED_ON_DATE_RANGES = [
  DEFAULT_ET3_PICKER_SINGLE_VALUE,
  { label: "Yesterday", value: "YESTERDAY" },
  { label: "Last week", value: "LAST_WEEK" },
  { label: "Last 2 weeks", value: "LAST_2_WEEKS" },
  { label: "Last month", value: "LAST_MONTH" },
  { label: "Last 3 months", value: "LAST_3_MONTHS" },
  { label: "Last 6 months", value: "LAST_6_MONTHS" }
];
